module.exports = {
  Graph: require('./lib/graph'),
  json: require('./lib/json'),
  alg: require('./lib/alg')
}
